import { NgModule } from "@angular/core";
import { Route, RouterModule } from "@angular/router";
import { MustBeAuthenticatedGuard } from "angular-security-oauth";
import { KeycloakGuard } from "./commons/core/session/keycloak.guard";
import { Role } from "./commons/models/role";
import { linksRoles } from "./linksRoles";

export interface RouteData {
	requiredRoles?: Role[][]
}

export interface AppRoute extends Route {
	data?: RouteData;
}

const routes: AppRoute[] = [
	{
		path: 'contexts',
		data: {
			requiredRoles: linksRoles.contexts
		},
		canActivate: [MustBeAuthenticatedGuard, KeycloakGuard],
		loadChildren: () => import('./contexts/contexts.module').then(m => m.ContextsModule)
	},
	{
		path: 'templates',
		data: {
			requiredRoles: linksRoles.templates
		},
		loadChildren: () => import('./templates/templates.module').then(m => m.TemplatesModule)
	},
	{
		path: 'translations',
		data: {
			requiredRoles: linksRoles.translations
		},
		canActivate: [MustBeAuthenticatedGuard, KeycloakGuard],
		loadChildren: () => import('./translations/translations.module').then(m => m.TranslationsModule)
	},
	{
		path: 'offline-flags',
		data: {
			requiredRoles: linksRoles.offlineFlags
		},
		canActivate: [MustBeAuthenticatedGuard, KeycloakGuard],
		loadChildren: () => import('./offline/offline-flags.module').then(m => m.OfflineFlagsModule),
	},
	{
		path: 'sequences',
		data: {
			requiredRoles: linksRoles.sequences
		},
		canActivate: [MustBeAuthenticatedGuard, KeycloakGuard],
		loadChildren: () => import('./sequences/sequences.module').then(m => m.SequencesModule)
	},
	{
		path: 'timers',
		data: {
			requiredRoles: linksRoles.timers
		},
		canActivate: [MustBeAuthenticatedGuard, KeycloakGuard],
		loadChildren: () => import('./timers/timers.module').then(m => m.TimersModule)
	},
	{
		path: 'contact',
		data: {
			requiredRoles: linksRoles.contact
		},
		canActivate: [MustBeAuthenticatedGuard, KeycloakGuard],
		loadChildren: () => import('./contact/contact.module').then(m => m.ContactModule)
	},
	{
		path: 'faq',
		data: {
			requiredRoles: linksRoles.faq
		},
		canActivate: [MustBeAuthenticatedGuard, KeycloakGuard],
		loadChildren: () => import('./faq/faq.module').then(m => m.FaqModule)
	},
	{
		path: 'csat',
		data: {
			requiredRoles: linksRoles.csat
		},
		canActivate: [MustBeAuthenticatedGuard, KeycloakGuard],
		loadChildren: () => import('./csat/csat.module').then(m => m.CSatModule)
	},
	{
		path: 'payment-config',
		data: {
			requiredRoles: linksRoles.paymentConfig
		},
		canActivate: [MustBeAuthenticatedGuard, KeycloakGuard],
		loadChildren: () => import('./payment-config/payment-config.module').then(m => m.PaymentConfigModule)
	},
	{
		path: 'partners',
		data: {
			requiredRoles: linksRoles.partner
		},
		canActivate: [MustBeAuthenticatedGuard, KeycloakGuard],
		loadChildren: () => import('./partners/partners.module').then(m => m.PartnersModule)
	},
	{
		path: 'origins',
		data: {
			requiredRoles: linksRoles.origin
		},
		canActivate: [MustBeAuthenticatedGuard, KeycloakGuard],
		loadChildren: () => import('./origins/origins.module').then(m => m.OriginsModule)
	},
	{
		path: 'sellers',
		data: {
			requiredRoles: linksRoles.seller
		},
		canActivate: [MustBeAuthenticatedGuard, KeycloakGuard],
		loadChildren: () => import('./sellers/sellers.module').then(m => m.SellersModule)
	},
	{path: '**', redirectTo: 'contexts', pathMatch: 'full'}
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload'}),
	],
	exports: [RouterModule]
})
export class AppRoutingModule {
}
